/* eslint-disable n/no-process-env */
export const localImageLoader = ({ src }: { src: string }) => {
  return `${src}`;
};
